import {
	createContext,
	default as React,
	type ReactNode,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { TemplatesReducer } from "../reducers/templatesReducer";

const TemplatesContext = createContext({
	state: TemplatesReducer.getInitialState(),
	actions: TemplatesReducer.actions,
});

export const useTemplatesContext = () => useContext(TemplatesContext);

export const TemplatesProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: TemplatesReducer.getInitialState(),
		reducers: TemplatesReducer.caseReducers,
	});

	return (
		<TemplatesContext.Provider value={{ state, actions }}>
			{children}
		</TemplatesContext.Provider>
	);
};
